
import React, { useEffect, useState } from "react";

import {
    CircularProgress,
    Button,
    styled
} from "@mui/material";

const StyledLoader = styled(CircularProgress)({
    '&.MuiCircularProgress-root': {
        width: "16px !important",
        height: "16px !important",
        marginLeft: "10px"
    }
})

const ButtonLoader = (props) => {
    return (
        <>
            {
                props?.outlined == undefined ?
                    <Button
                        variant="outlined"
                        className='payment-theme-btn-cancel spin-loader'
                        sx={{
                            height: "40px",
                        }}
                    >
                        {
                            props.title || "Loading..."
                        }
                        <StyledLoader
                            sx={{
                                color: "var(--theme-error-color) !important",
                            }}
                        />
                    </Button>
                    : <Button
                        variant="filled"
                        className='payment-theme-btn-success'
                        sx={{
                            color: "#fff",
                            border: 0,
                            height: "40px"
                        }}
                    > {
                            props.title || "Loading..."
                        }
                        <StyledLoader

                            sx={{
                                color: "#fff !important"
                            }}
                        />
                    </Button>
            }
        </>
    )
}

export default ButtonLoader;